import React from "react";
import { BrowserRouter } from "react-router-dom";

import HomePage from "./pages/HomePage";
import ScrollToTop from "./components/ScrollToTop";


export default () => (

  <BrowserRouter basename="/">
    <ScrollToTop />
    <HomePage />
  </BrowserRouter>
  
  )
